import React, { Component } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";

import arrowUp from "../../assets/img/arrow.svg";

import "./BackToTop.css";

export default class BackToTop extends Component {
  render() {
    return (
      <div className="back-to-top">
        <AnchorLink href="#home">
          <img src={arrowUp} alt="back-to-top" />
        </AnchorLink>
      </div>
    );
  }
}
